/**
 * Copy text to the clipboard, resolving to whether it succeeded.
 *
 * Prefers the async Clipboard API (`navigator.clipboard.writeText`), which needs a
 * secure context (https/localhost) and can reject; falls back to a hidden-textarea
 * `execCommand('copy')` so a copy still works on http origins and degrades safely in
 * test/JSDOM environments. Never throws — callers branch on the boolean for feedback.
 */
export async function copyToClipboard(text: string): Promise<boolean> {
  try {
    if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    // Fall through to the legacy path (e.g. permission denied / insecure context).
  }
  try {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    const ok = document.execCommand('copy');
    textarea.remove();
    return ok;
  } catch {
    return false;
  }
}
